<template lang="pug">
  #MsgManagerIndex.container-width
    // 新增用於切換已讀和未讀訊息的選項卡
    b-tabs.mt-2(justified v-model="activeTabIndex")
      b-tab(v-for="(tab, index) in tabOptions" :key="index" :title="tab.title")
        template(v-slot:title v-if="tab.title === '未讀'")
          div.text-center.d-inline 未讀
          div(:style="{ 'text-align': 'end', 'position': 'relative', 'top': '-25px' }")
            b-badge.px-2.py-1(
              v-if="unreadMsgList.length > 0"
              :style="{ 'color': '#fff', 'background-color': 'red' }"
            ) NEW
        div.msg-manager.p-3
          // 訊息列表
          b-card(
            class="border-0 mb-2 customerCard word-break-all",
            bg-variant="light",
            v-for="(user,index) in msgList",
            :key="user.id",
            @click="openMsgHandler(user)"
          )
            .row.no-gutters
              .col-10.pr-1
                .row.align-items-center.no-gutters
                  .col-4.pr-2
                    ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                      :profileUrl="user.picture_url",
                      :style="{ 'width': '60px', 'height': '60px' }"
                    )
                  .col-8.pl-2
                    p.mb-0 姓名: {{ user.member_first_name }}
                    p.mb-0 暱稱名: {{ user.display_name }}
                    p.mb-2 備註名: {{ user.note_name }}
                .row.align-items-center.no-gutters.position-relative
                  .line.position-absolute
                  .msgText.mb-0.text-gray.d-block.w-100.text-overflow-ellipsis {{ user | filterMessage }}
              .col-2.pl-1.d-flex.flex-column.justify-content-between.align-items-end.position-relative
                b-badge.chatTagStyle(
                  variant="primary",
                  v-if="user.is_read === 0"
                ) NEW
                small.mb-0.d-block.w-100.text-right.isRead(
                  v-if="user.is_read === 1"
                ) 已讀取
                small.mb-0.d-block.w-100.text-right.position-absolute.dateStyle {{ moment(user.last_message_at).format('MM/DD')  }}
          infinite-loading(
            @infinite="infiniteHandler",
            :identifier="infiniteId",
            spinner="bubbles"
          )
            .cursor-default(slot="no-more") 無更多資料
            .cursor-default(slot="no-results") 無更多資料
            .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import { SM_CHAT_ROOM_INDEX } from '@/router/sm/chat-room';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
// websocket 監聽
import Echo from 'laravel-echo';

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'MsgManagerIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      activeTabIndex: 0,
      tabOptions: [
        {
          title: "已讀",
        },
        {
          title: "未讀",
        }
      ],
      infiniteId: +new Date(),
      isReadFirstLoad: false,
      isUnReadFirstLoad: false,
      isInitTab: false,
    };
  },
  filters: {
    // 過濾最後一則訊息
    filterMessage(value) {
      // 使用者名稱
      const userName = value.display_name;
      // JSON化訊息
      let message = JSON.parse(value.message);
      // 用來放會回傳的訊息
      let returnText = '';
      // 判斷是 user 傳送或是 host 傳送
      // m2p 為 user 傳送 => '會員to顧問'
      if (value.direction === 'm2p') {
        // 判斷種類
        switch (message.type) {
          case 'text':
            returnText = message.text;
            break;
          case 'image':
            returnText = `${userName}傳送了圖片`;
            break;
          case 'video':
            returnText = `${userName}傳送了影片`;
            break;
          case 'voice':
            returnText = `${userName}傳送了語音訊息`;
            break;
          case 'sticker':
            returnText = `${userName}傳送了貼圖`;
            break;
          case 'location':
            returnText = `${userName}向您傳送了位置訊息`;
            break;
          default:
            returnText = `${userName}向您傳送了一則訊息`;
            break;
        }
        return returnText;
      }
        // 其餘都是 host 傳送
        // p2m => '顧問to會員', s2m => '系統to會員', s2p => '系統to顧問'

        // 判斷種類
        // 如果是模板，取最後一筆重組
        if (message.type === 'template') {
          message = _.last(message.data);
        }
        switch (message.type) {
          case 'text':
            if (Object.keys(message.text).length > 22) {
              returnText = `${message.text.replace(/\s+/g, '').substr(0, 22) }...`;
            } else if (Object.keys(message.text).length < 1) {
              returnText = '文字訊息已傳送';
            } else {
              returnText = message.text;
            }
            break;
          case 'image':
            returnText = '圖片已傳送';
            break;
          case 'video':
            returnText = '影片已傳送';
            break;
          case 'voice':
            returnText = '語音訊息已傳送';
            break;
          case 'sticker':
            returnText = '貼圖已傳送';
            break;
          case 'location':
            returnText = '位置訊息已傳送';
            break;
          case 'carousel':
            returnText = '橫向捲軸已傳送';
            break;
          default:
            returnText = '您傳送了一則訊息';
            break;
        }
        return returnText;
    }
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sm_msg_manager/resetHandler');
    vm.$store.commit('toggleLoading', false);
  },
  mounted() {
    const vm = this;
    let updatesBatch = [];
    // 未讀判斷 只要檢查至少1筆就好
     vm.$store.dispatch('sm_msg_manager/getUnreadListOnceHandler', {
      current_page: 0,
      per_page: 1,
     }).then(() => {
      // 第一次進來有未讀的話則切換到未讀頁籤
      vm.isUnReadFirstLoad = true;
      if (vm.isReadFirstLoad) {
        if(!vm.isInitTab && vm.unreadMsgList.length > 0) vm.activeTabIndex = 1;
        vm.isInitTab = true;
        vm.$swal.close();
      }
    });

    // 取得個人資料, 要先去拿這個顧問的 sa_id
    vm.$store.dispatch('sm_profile/getProfileHandler')
      .then(() => {
        // todo 移到拿的到 sa_id 的地方，但是避免無限捲軸打 api 一直執行, console.log(this.sa_id) 確認
        // websocket
        window.io = require('socket.io-client');
        window.Echo = new Echo({
          broadcaster: 'socket.io',
          host: process.env.VUE_APP_WEBSOCKET_URL,
          transports: ['websocket', 'polling', 'flashsocket'],
          auth: {
            headers: {
              Authorization: window.sessionStorage.getItem('token'),
              Source: 'one-to-one'
            }
          }
        });
        // 加入 Channel
        const channelName = `one_to_one_${vm.smProfileData.id}_${process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID}`;
        window.Echo.private(channelName)
          .listen('.line.one-to-one-frontend', (e) => {
            // 添加更新到批處理
            updatesBatch.push(() => {
              vm.$store.commit('sm_msg_manager/resetHandler');
              vm.infiniteId += 1;
            });

            // 在短暫延遲後應用更新（根據需要調整）
            setTimeout(() => {
              updatesBatch.forEach(update => update());
              updatesBatch = [];
            }, 200);
          });
      });
  },
  methods: {
    moment(val) {
      return moment(val).isValid() ? moment(val) : moment();
    },
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch(`sm_msg_manager/get${vm.activeTabIndex === 0 ? '' : 'Unread'}ListHandler`, {
        current_page: parseInt(vm.pagination.current_page) + 1,
        per_page: parseInt(vm.pagination.per_page)
      }).then(() => {
        vm.isReadFirstLoad = true;
        if (vm.isUnReadFirstLoad) {
          if (!vm.isInitTab && vm.unreadMsgList.length > 0) vm.activeTabIndex = 1;
          vm.isInitTab = true;
          vm.$swal.close();
        }
        if (vm.pagination.current_page === 0 || vm.pagination.total_page === 0) {
          $state.complete();
        }

        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    openMsgHandler(user) {
      const vm = this;
      user.sa_picture = vm.smProfileData.picture_url;

      vm.$router.push({
        name: SM_CHAT_ROOM_INDEX,
        params: {
          chatRoomTitle: `與${user.display_name}對話`,
          user,
          sa_id: vm.smProfileData.id
        }
      });
    }
  },
  computed: {
    ...mapState({
      readMsgList: (state) => state.sm_msg_manager.readMsgList,
      unreadMsgList: (state) => state.sm_msg_manager.unreadMsgList,
      pagination: (state) => state.sm_msg_manager.pagination,
      smProfileData: (state) => state.sm_profile.data
    }),
    msgList() {
      if (this.activeTabIndex === 0) {
        return this.readMsgList;
      } else {
        return this.unreadMsgList;
      }
    },
  },
  watch: {
    activeTabIndex(newValue, oldValue) {
      this.$store.commit('sm_msg_manager/resetHandler');
      this.infiniteId += 1;
      // 切回已讀時多打一次未讀判斷 只要檢查至少1筆就好
      if (newValue === 0) {
        this.$store.dispatch('sm_msg_manager/getUnreadListOnceHandler', {
          current_page: 0,
          per_page: 1,
        });
      }
    }
  },
  beforeDestroy() {
    const vm = this;
    // 離開前結束 websocket 監聽事件
    window.Echo.disconnect();
  }
};
</script>

<style>
  .nav-link.active {
    background-color: #362e25 !important;
    color: #fff !important;
  }
  .nav-link {
    height: 45px;
    border: 1px solid #362e25 !important;
  }
  .msg-manager {
    border-left: 1px solid #362e25;
    border-right: 1px solid #362e25;
    border-bottom: 1px solid #362e25;
  }
</style>
